/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Change_WarningInputs */



/**
* | output |
* | --- |
* | "An email will be sent to you. Once your new password is set, you will be logged out and will need to log in again." |
*
* @param {Password_Change_WarningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const password_change_warning = /** @type {((inputs?: Password_Change_WarningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Change_WarningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("An email will be sent to you. Once your new password is set, you will be logged out and will need to log in again.")
	return /** @type {LocalizedString} */ ("Un email vous sera envoyé. Une fois votre nouveau mot de passe défini, vous serez déconnecté et devrez vous reconnecter.")
});